import findById from 'helpers/findById'
import replaceCamera from 'helpers/cameras/replaceCamera'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import calculatorUpdateHelpers from 'helpers/calculatorUpdateHelpers'
import { ValidationError } from 'helpers/validator/validator'

export default function updateCamera(state, action) {
  const camera = findById({ id: action.id, state: state.cameras })

  if (!camera) return state

  const updatedCamera = calculatorUpdateHelpers()[`update${capitalizeFirstLetter(action.key)}`](camera, action.value)

  const keysToCheck = ['distance', 'distanceToTarget', 'ppf', 'tilt', 'horizontalAngleOfView', 'verticalAngleOfView', 'horizontalFieldOfView', 'verticalFieldOfView']
  const isInvalid = val => (!val && val !== 0) || val === Infinity

  if (keysToCheck.some(key => isInvalid(updatedCamera[key]))) throw new ValidationError('Invalid input')

  return replaceCamera({ id: camera.id, updatedCamera, state })
}



// WEBPACK FOOTER //
// ./src/reducers/updateCamera.js